import { render, staticRenderFns } from "./wechat_live.vue?vue&type=template&id=20ba9f2c&scoped=true"
import script from "./wechat_live.vue?vue&type=script&lang=js"
export * from "./wechat_live.vue?vue&type=script&lang=js"
import style0 from "./wechat_live.vue?vue&type=style&index=0&id=20ba9f2c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba9f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ba9f2c')) {
      api.createRecord('20ba9f2c', component.options)
    } else {
      api.reload('20ba9f2c', component.options)
    }
    module.hot.accept("./wechat_live.vue?vue&type=template&id=20ba9f2c&scoped=true", function () {
      api.rerender('20ba9f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/wechat_live.vue"
export default component.exports